import { useMutation, useQueryClient } from '@tanstack/react-query';
import restClient from '../common/api/restClient';

export const useUpdateBanner = () => {
  const queryClient = useQueryClient();
   const prefix = process.env.REACT_APP_PROXY_PREFIX || '';
  return useMutation({
    mutationFn: async ({ id, input }) => {
      const result = await restClient({
        url: `${prefix}/banner/${id}`,
        method: 'PUT',
        data: input
      });
      return result;
    },
    onSuccess: () => {
      // Invalidate and refetch banners list and single banner after successful update
      queryClient.invalidateQueries(['banners']);
      queryClient.invalidateQueries(['banner']);
    }
  });
};
